import Social from "@/components/Social";
import Newsletter from "@/components/Newsletter";

export default function SocialsPage() {
  return (
    <div className="pt-16" data-testid="socials-page">
      <Social />
      <Newsletter />
    </div>
  );
}
